/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */



angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodDayPr_Resource',["$resource","$location",
        function ($resource,$location) {
        let baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl+'rest/workingPeriodDayPrs/:id',{}, {});
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodDayPr',["WorkingPeriodDayPrData","WorkingPeriodDayPr_Resource","Activity","Period",
        function (WorkingPeriodDayPrData,WorkingPeriodDayPr_Resource,Activity,Period) {
        //WorkingPeriodDay inherit of $resource

        let  WorkingPeriodDayPr = function (resource,workingPeriodDay, isApplicationLoading) {
            this.id = null;
            this.prUnitId = null;
            this.workingPeriodDay = null;
            this.physicalResourceId = null;
            this.specificPeriod = false;
            this.onLineBooking = true;
            this.period = null; //Period null means no work for resource
            this.activities = [];

            WorkingPeriodDayPrData.add(this);

            if (workingPeriodDay!==undefined)
                this.workingPeriodDay = workingPeriodDay;
            if (resource!==undefined && resource!=null)
            {
                this.loadObject(resource, isApplicationLoading);
            }
        };
        WorkingPeriodDayPr.prototype.loadObject = function(object, isApplicationLoading) {
            if (!this.id) {
                this.id = object.id;
            }
            this.prUnitId = object.prUnitId;
            this.physicalResourceId = object.physicalResourceId;
            this.specificPeriod = object.specificPeriod;
            this.onLineBooking = object.onLineBooking;
            let activity;
            if (object.activities)
                for (let i =0;i< object.activities.length;i++) {
                    activity = new Activity(object.activities[i], null, isApplicationLoading);
                    activity.workingPeriodDayPr = this;
                    this.activities.push(activity);
                }
            this.setPeriod(object.period);
        };
        WorkingPeriodDayPr.prototype.setPeriod = function(period)
        {
            if (period) {
                this.period = new Period(period);
            } else {
                this.period = null;
            }
        };
        WorkingPeriodDayPr.prototype.getObjectResource = function() {
            let res = new WorkingPeriodDayPr_Resource();
            res.id = this.id;
            res.prUnitId = this.prUnitId;
            res.physicalResourceId = this.physicalResourceId;
            res.specificPeriod = this.specificPeriod;
            res.onLineBooking = this.onLineBooking;
            if (this.workingPeriodDay)
                res.workingPeriodDayId=this.workingPeriodDay.id;
            res.activities=[];
            if (this.activities) {
                for (let i = 0; i < this.activities.length; i++) {
                    res.activities.push(this.activities[i].getObjectResource());
                }
            }
            if (this.period) {
                res.period = this.period.getObjectResource();
            }

            return  res;
        };
        WorkingPeriodDayPr.prototype.setId = function(id) {
            this.id = id;
        };
        WorkingPeriodDayPr.prototype.getId = function() {
            return this.id;
        };
        WorkingPeriodDayPr.prototype.addActivity = function(activity) {
            if (activity) {
                this.activities.push(activity);
                activity.workingPeriodDayPr = this;
            }
        };
        WorkingPeriodDayPr.prototype.removeActivity = function(activity) {
            if (activity) {
                let index = this.activities.indexOf(activity);
                if (index !== -1)
                    this.activities.splice(index,1);
            }
        };
        WorkingPeriodDayPr.prototype.getActivityById = function(id)
        {
            for (let i =0;i< this.activities.length;i++) {
                if (this.activities[i].id === id) {
                    return this.activities[i];
                }
            }
            return null;
        };

        return WorkingPeriodDayPr;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodDayPrSrv',["$log","WorkingPeriodDayPr_Resource","UserActionData","WorkingPeriodDayPrData","ServerSrv",
        function ($log,WorkingPeriodDayPr_Resource,UserActionData,WorkingPeriodDayPrData,ServerSrv) {
        let workingPeriodDayPrSrv = {};

        workingPeriodDayPrSrv.save = function(workingPeriodDayPr,successFunction,errorFunction) {
            ServerSrv.startSavingProcess(workingPeriodDayPrSrv.saveSync, workingPeriodDayPr, successFunction, errorFunction);
        };
        workingPeriodDayPrSrv.saveSync =  function(workingPeriodDayPr,successFunction,errorFunction) {

            let workingPeriodDayPrRes = workingPeriodDayPr.getObjectResource();
            workingPeriodDayPrRes.$save({}, //no params
                function (data) {
                    try{
                        workingPeriodDayPr.setId(data.id);
                        UserActionData.add(data.userAction);
                        if (data.activitiesId && data.activitiesId.length === workingPeriodDayPr.activities.length)
                        //Assume that returned list has the same order
                            for (let i=0;i< data.activitiesId.length;i++)
                                workingPeriodDayPr.activities[i].setId(data.activitiesId[i]);
                        //Add user action
                        //UserActionSrv.add(data.userAction);
                        //CallBack on success
                        if (successFunction != undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {
                    try{
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        workingPeriodDayPrSrv.remove =  function(workingPeriodDayPr,successFunction,errorFunction) {
            ServerSrv.startSavingProcess(workingPeriodDayPrSrv.removeSync, workingPeriodDayPr, successFunction, errorFunction);
        };
        workingPeriodDayPrSrv.removeSync =  function(workingPeriodDayPr,successFunction,errorFunction) {
            //$timeout (function () {

            let workingPeriodDayPrRes = new WorkingPeriodDayPr_Resource();
            workingPeriodDayPrRes.$remove({id:workingPeriodDayPr.id}, //no params
                function (data) {
                    try {
                        //Add user action
                        //UserActionSrv.add(data.userAction);
                        //CallBack on success
                        if (successFunction != undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        workingPeriodDayPrSrv.updateLocally =  function(id,objectToRestore) {
            let wpDayPr =  WorkingPeriodDayPrData.getById(id);
            if (wpDayPr!=null) {
                wpDayPr.loadObject(objectToRestore);
            }
            return wpDayPr;
        };
        workingPeriodDayPrSrv.removeLocally =  function(id, object) {
            let wpDayPr =  WorkingPeriodDayPrData.getById(id);
            if (wpDayPr != null) {
                wpDayPr.workingPeriodDay.removeWorkingPeriodDayHr(wpDayPr)
            }
            return wpDayPr;
        };
        workingPeriodDayPrSrv.addLocally =  function(id,objectToRestore) {
            let wpDayPr =  WorkingPeriodDayPrData.getById(id);
            if (wpDayPr!=null) {
                wpDayPr.loadObject(objectToRestore);
                WorkingPeriodDayPrData.add(wpDayPr);
            }
            return wpDayPr;
        };

        return workingPeriodDayPrSrv;
    }
    ]);


angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodDayPrData',[
        function () {
        let workingPeriodDayPrData = {
            indexWorkingPeriodDayPrs : []
        };
        workingPeriodDayPrData.getById =  function(workingPeriodDayPrId) {
            for (let i=0;i<this.indexWorkingPeriodDayPrs.length;i++)
                if (this.indexWorkingPeriodDayPrs[i].id == workingPeriodDayPrId)
                    return this.indexWorkingPeriodDayPrs[i];
            return null;
        };
        workingPeriodDayPrData.getByIndex =  function(servIndex) {
            if (servIndex>=0 && servIndex<this.indexWorkingPeriodDayPrs.length)
                return this.indexWorkingPeriodDayPrs[servIndex];
            else
                return null;
        };
        workingPeriodDayPrData.getIndexOf =  function(workingPeriodDayPr) {
            if (workingPeriodDayPr)
                return this.indexWorkingPeriodDayPrs.indexOf(workingPeriodDayPr);
            return -1;
        };
        workingPeriodDayPrData.add =  function(workingPeriodDayPr) {
            this.indexWorkingPeriodDayPrs.push(workingPeriodDayPr);
            return this.indexWorkingPeriodDayPrs.length-1;
        };
        workingPeriodDayPrData.clear =  function() {
            workingPeriodDayPrData.indexWorkingPeriodDayPrs = [];
        };
        return workingPeriodDayPrData;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/WorkingPeriodDayPr.js